import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import React from "react";
import { getAveragedHeaders } from "../constants/AveragedHeaders";
import ConfigurableRow from "./averaged-rows/configurable-row";
import {
  baseConfig,
  manufacturerConfig,
  brandConfig,
  modelConfig,
} from "./averaged-rows/calibration-config";

export default function AveragedCalibrationsTable({
  data,
  clickedOption,
  removeGroupHandler,
  updateData,
  isDetailedData,
}) {
  const configMap = {
    0: baseConfig,
    1: manufacturerConfig,
    2: brandConfig,
    3: modelConfig,
  };

  const activeConfig = configMap[clickedOption];
  const headers = getAveragedHeaders(clickedOption, isDetailedData);

  if (!activeConfig) {
    return null;
  }

  const columnWidths = activeConfig.getColumnWidths({ isDetailedData });

  return (
    <TableContainer component={Paper}>
      <Table style={{ tableLayout: "fixed" }}>
        <colgroup>
          {columnWidths.map((width, index) => (
            <col key={index} style={{ width }} />
          ))}
        </colgroup>
        <TableHead>
          <TableRow>
            {headers.map((header, index) => (
              <TableCell key={index}>{header}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((dataRow) => (
            <ConfigurableRow
              key={dataRow.id}
              data={dataRow}
              updateData={updateData}
              config={activeConfig}
              removeGroupHandler={removeGroupHandler}
              isDetailedData={isDetailedData}
              mainCalibrations={
                Array.isArray(dataRow.calibrations)
                  ? dataRow.calibrations.map(
                      (calibration) => calibration.appVolume,
                    )
                  : []
              }
              selectedOption={clickedOption}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
